import { render, staticRenderFns } from "./AddMediaToTest.vue?vue&type=template&id=96df2d34&scoped=true&"
import script from "./AddMediaToTest.vue?vue&type=script&lang=js&"
export * from "./AddMediaToTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96df2d34",
  null
  
)

export default component.exports